import { faClose, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import LinkButton from 'components/buttons/LinkButton/LinkButton';
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { IFilterValue } from 'interfaces/tyre';
import Spinner from 'components/spinner/Spinner';
import useHttp from 'utils/hooks/useHttp';
import axios from 'axios';
import { useOnClickOutside } from 'utils/hooks/useOnClickOutside';
import { IBatteryFilter } from 'interfaces/battery';
import TextInput from 'components/inputs/TextInput/TextInput';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import { INonTecDocPart, IParamsNonTecdocParts } from 'interfaces/nonTecdocCatalog';
import './NonTecdocPartsFilter.scss';


type Props = {
  setOpenFilter?: (boolean) => void;
  openFilter?: boolean;
  filter?
  loadingFilter: boolean;
  setData: Dispatch<SetStateAction<INonTecDocPart[]>>;
  setTotalPage: Dispatch<SetStateAction<number>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setSelectAll?;
  setSelectedData?;
};

const NonTecdocPartsFilter: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const { control, getValues, setValue, reset } = useForm();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const http = useHttp();
  const cancelToken = axios.CancelToken.source();
  const [searchFilter, setSearchFilter] = useState<IParamsNonTecdocParts | {}>({});
  const [supplier, setSupplier] = useState<IFilterValue[]>([]);
  const filterRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const { isMobile, isTablet } = useDeviceDetect();

  // useOnClickOutside(filterRef, (event) => {
  //   if (
  //     props.openFilter &&
  //     (event?.target as HTMLElement).tagName !== 'svg' &&
  //     (event?.target as HTMLElement).tagName !== 'parh' &&
  //     !(event?.target as HTMLElement).className.includes('indicatorContainer')
  //   ) {
  //     handleClick();
  //   }
  // });

  useEffect(() => {
    if (props.filter) {
      setSupplier(props.filter);

      if (Array.from(searchParams).length) {
        searchParams.forEach((value, key) => {
         

          if (key == 'supplier_ids[]') {
            const activeSupplier = searchParams.getAll('supplier_ids[]').map((id) => {
              return props.filter?.find((item) => item.value == Number(id));
            });

            setValue('supplier', activeSupplier);
          }

    
        });
      }
    }
  }, [props.filter, searchParams.get('supplier_ids[]')]);

  function handleClick() {
    const value = getValues();

    const params = {
      supplier_ids: (value.supplier && value.supplier.map((item) => item.value)) || [],
    };

    const validParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (value === undefined || value === '') {
        return acc;
      }

      acc[key + '[]'] = value;

      acc['page'] = String(1);

      return acc;
    }, {});

    const searchParams = createSearchParams(validParams);

    navigate({
      search: `?${searchParams}`,
    });
    props.setLoading(true);

    setSearchFilter(params);
    props.setOpenFilter!(false);
  }

  function handleReset() {
    reset({ supplier: '' });
    navigate({ search: '?' });
    props.setOpenFilter!(false);
    props.setLoading(true);
    setSearchFilter({ page: 1 });
  }

  useEffect(() => {
    if (Object.keys(searchFilter).length) {
      http.nonTecDocCatalog
        .getNonTecdocParts(searchFilter, cancelToken.token)
        .then((resp) => {
          props.setSelectAll(false);
          props.setSelectedData([]);
          props.setData(resp.data.data);
          props.setTotalPage(resp.data.total_pages);
          props.setLoading(false);
        })
        .catch(() => {
          props.setSelectAll(false);
          props.setSelectedData([]);
        });

      return () => {
        cancelToken.cancel();
      };
    }
  }, [searchFilter]);

  return (
    <div ref={filterRef} className={`non_tecdoc-filter ${props.openFilter ? 'active' : ''}`}>
      <div className="header">
        <div className="buttons-container">
          <LinkButton title={t('_reset_filters')} icon={faRedo} onClick={handleReset} />
        </div>
        <div onClick={() => props.setOpenFilter!(false)}>
          <FontAwesomeIcon className="icon" icon={faClose} />
        </div>
      </div>
      <div className="title">
        <Trans i18nKey="_filter_results" components={{ b: <strong /> }} />
      </div>

      {props.loadingFilter ? (
        <Spinner class="small" />
      ) : (
        <div className="filters">
          <div className="categories-filter">
            <div className="dropdown-item">
              <label className="dropdown-label">{t('_supplier')}</label>
              <Controller
                control={control}
                name="supplier"
                render={({ field: { onChange, value } }) => (
                  <Select
                    value={value}
                    className="tyre-filter-select-dropdown"
                    onChange={(val) => {
                      onChange(val);
                    }}
                    options={supplier}
                    placeholder={`${t('_select')}  ${t('_supplier')}`}
                    menuPlacement="auto"
                    isMulti
                    menuPosition="fixed"
                    styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                    isSearchable={!isMobile && !isTablet}
                  />
                )}
              />
            </div>
          </div>
        </div>
      )}
      <div className="apply-btn">
        <DefaultButton text={t('_apply')} onClick={() => handleClick()} />
      </div>
    </div>
  );
};

export default NonTecdocPartsFilter;
